"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'CardDashRoutes',
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: [String, Number],
      default: ''
    }
  }
};